// src/components/shops/postTemplates/NowServing.tsx
//
// The standing weekly list — espresso, filter, guest roaster — set with dotted
// leaders like a printed menu.
//
// The repetition is the value. A shop that posts this every Monday teaches its
// regulars to look for it, and refreshing it takes two minutes. It reads rows
// out of the body ("Espresso: Kenya Nyeri"), so there is nothing new to fill in.

import SocialBrewBadge from '../SocialBrewBadge'
import { parseRows, bodyLines, type TemplateProps } from './types'

export default function NowServing({
  title, body, shopName, rating, ratingCount, scale = 1,
}: TemplateProps) {
  const px = (n: number) => `${n * scale}px`
  const rows = parseRows(body)
  const lines = rows ? [] : bodyLines(body)

  return (
    <div
      style={{
        background: '#faf6ef',
        border: `${px(1)} solid #e8d8c0`,
        borderRadius: px(4),
        padding: `${px(20)} ${px(18)} ${px(16)}`,
      }}
      data-shop={shopName}
    >
      <p
        style={{
          fontSize: px(9),
          letterSpacing: '0.34em',
          textTransform: 'uppercase',
          color: '#a88660',
          fontWeight: 700,
          textAlign: 'center',
        }}
      >
        Now serving
      </p>
      <h3
        className="font-display"
        style={{
          fontSize: px(22),
          lineHeight: 1.15,
          color: '#241810',
          fontWeight: 700,
          textAlign: 'center',
          margin: `${px(6)} 0 ${px(16)}`,
          textWrap: 'balance',
        }}
      >
        {title}
      </h3>

      {rows ? (
        <div>
          {rows.map((r, i) => (
            // Leaders are a middle column that simply runs out of room, which
            // is how a printed menu does it and why the dots always line up.
            <div key={i} className="flex items-baseline" style={{ gap: px(6), marginBottom: px(9) }}>
              <span
                style={{
                  fontSize: px(11),
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  color: '#8c6a48',
                  fontWeight: 700,
                  flexShrink: 0,
                }}
              >
                {r.label}
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: `${px(1)} dotted #d4b896`,
                  transform: `translateY(${px(-3)})`,
                }}
              />
              <span
                className="font-display"
                style={{ fontSize: px(13.5), color: '#241810', fontWeight: 700, flexShrink: 0, textAlign: 'right' }}
              >
                {r.value}
              </span>
            </div>
          ))}
        </div>
      ) : (
        lines.map((line, i) => (
          <p
            key={i}
            style={{ fontSize: px(13), lineHeight: 1.7, color: '#6e5038', textAlign: 'center', margin: 0 }}
          >
            {line}
          </p>
        ))
      )}

      <div style={{ marginTop: px(18) }}>
        <SocialBrewBadge rating={rating} ratingCount={ratingCount} tone="light" scale={scale} />
      </div>
    </div>
  )
}
